import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/.pnpm/@mui+material@7.0.2_@emotion+react@11.14.0_@types+react@19.1.3_react@19.1.0__@emotion+styled@_765riollhjmnq7z73qoc3lxldq/node_modules/@mui/material/esm/Typography/Typography.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.3.1_@opentelemetry+api@1.9.0_react-dom@19.1.0_react@19.1.0__react@19.1.0_sass@1.86.3/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.3.1_@opentelemetry+api@1.9.0_react-dom@19.1.0_react@19.1.0__react@19.1.0_sass@1.86.3/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[lang]/shop/shop-category.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/navigation/Pagination/Pagination.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Price/PriceGrid.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Product/ProductCard/DynamicAddToCartButton.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Product/ProductCard/DynamicProductTitle.jsx");
